var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.Template)?_c(_setup.Dropdown,{attrs:{"modal-name":_setup.ddName,"anchor-id":_setup.anchorId,"placement":_setup.placement,"fallbackPlacements":_setup.fallbackPlacements}},[_c(_setup.Template,{on:{"close":_setup.close}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }